import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout from "../Layout/Layout";
import Loading from "../Loading/Loading";
import Styles from "./notice.module.css";

function Notice({ check }) {
  const [notices, setNotices] = useState([]);
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchStatus, setSearchStatus] = useState("idle"); // idle, searching, done
  const [error, setError] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [noticesRes, datesRes] = await Promise.all([
          axios.get(`${check.state.apiUrl}getNotices.php?key=${check.state.publicKey}`),
          axios.get(`${check.state.apiUrl}getNoticeDate.php?key=${check.state.publicKey}`)
        ]);

        if (noticesRes.data.status === 400 || datesRes.data.status === 400) {
          alert("Failed to fetch data.");
        } else {
          setNotices(noticesRes.data);
          setDates(datesRes.data);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [check.state.apiUrl, check.state.publicKey]);

  const validateDates = (from, to) => {
    if (!from || !to) return "Please select both dates.";
    if (new Date(from) > new Date(to)) return "From date cannot be after To date.";
    return "";
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const errMsg = validateDates(dateRange.from, dateRange.to);
    if (errMsg) return setError(errMsg);

    setError("");
    setSearchStatus("searching");

    try {
      const res = await axios.post(
        `${check.state.apiUrl}getrangenotice.php?key=${check.state.publicKey}`,
        { date1: dateRange.from, date2: dateRange.to }
      );

      if (res.data.status === 400) {
        alert("Failed to fetch notices.");
      } else {
        setNotices(res.data);
        setSearchStatus("done");
        setTimeout(() => setSearchStatus("idle"), 2000);
      }
    } catch (err) {
      console.error(err);
      alert("Error fetching data.");
      setSearchStatus("idle");
    }
  };

  if (loading) return <Loading />;

  return (
    <Layout>
      <div className={`container-fluid ${Styles.haha}`}>
        <div className="row">
          <div className="col-lg-1"></div>

          {/* date selector */}
          <div className={`col-lg-6 ${Styles.sec1}`}>
            <div className={`row ${Styles.date}`}>
              <div className={`col-lg-6 ${Styles.from}`}>
                <label>From</label>
                <select
                  value={dateRange.from}
                  onChange={(e) => setDateRange({ ...dateRange, from: e.target.value })}
                >
                  <option value="">Choose Date</option>
                  {dates.map((d) => (
                    <option key={d.date} value={d.date}>{d.date}</option>
                  ))}
                </select>
              </div>

              <div className={`col-lg-6 ${Styles.to}`}>
                <label>To</label>
                <select
                  value={dateRange.to}
                  onChange={(e) => setDateRange({ ...dateRange, to: e.target.value })}
                >
                  <option value="">Choose Date</option>
                  {dates.map((d) => (
                    <option key={d.date} value={d.date}>{d.date}</option>
                  ))}
                </select>

                <button
                  className={Styles.btn}
                  style={{
                    background:
                      searchStatus === "idle" ? "#3199f7"
                      : searchStatus === "searching" ? "yellow"
                      : "green"
                  }}
                  onClick={handleSearch}
                >
                  {searchStatus === "idle" ? "Search"
                    : searchStatus === "searching" ? "Searching..."
                    : "Done"}
                </button>

                {error && <p style={{ color: "red" }}>{error}</p>}
              </div>
            </div>
          </div>

          {/* Notice list */}
          <div className="col-lg-5">
            <div className={Styles.notice}>
              <h1 className={Styles.title2} style={{ textAlign: "center" }}>NOTICE</h1>
              <div className={Styles.scroll}>
                {notices.length === 0
                  ? <p style={{ textAlign: "center" }}>No notices available.</p>
                  : notices.map((notice, i) => (
                      <div key={i} className={Styles.notices}>
                        <span className={Styles.tp}>{notice.topic}</span>
                        <span className={Styles.openbtn}>
                          <a
                            href={`https://recstudentportal.com/${notice.address}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Open
                          </a>
                        </span>
                      </div>
                    ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </Layout>
  );
}

export default Notice;
